<template>
  <div class="left-container">
    <!-- top list -->
    <div class="logo">
      <router-link :to="{ name: 'main' }">
        <transition
          name="logo-fade"
          mode="out-in"
        >
          <img
            v-if="isOpen"
            class="logo__img"
            src="@/assets/img/logo-text.svg"
            alt="logo"
            width="108"
            height="32"
          />
          <img
            v-else
            src="@/assets/img/logo-qb-blue.png"
            alt="logo"
            width="32"
            height="32"
          />
        </transition>
      </router-link>
    </div>
    <div class="left-container__wrapper">
      <div class="left-container__top">
        <template
          v-for="item in listMenu('top')"
          :key="item?.routeName"
        >
          <list-item
            :item="item"
            :route-name="item.routeName"
            :is-dropdown="item.isDropdown"
            :with-badge="!!item.withBadge"
            :radios="item.radios || []"
            :is-open="isOpen"
            :paths="item.paths"
          />
        </template>
      </div>
      <!-- {{ listMenu("top") }} -->
      <!-- {{ listMenu("bottom") }} -->

      <!-- bottom list -->
      <div class="left-container__bottom">
        <template
          v-for="item in listMenu('bottom')"
          :key="item?.routeName"
        >
          <list-item
            :item="item"
            :route-name="item.routeName"
            :is-dropdown="item.isDropdown"
            :with-badge="item.withBadge"
            :is-open="isOpen"
            :radios="item.radios || []"
            :paths="item.paths"
          />
        </template>
        <version />
      </div>
      <!-- :name="`small-arrow-tag-${isOpen ? 'on' : 'off'}`" -->
      <v-icon
        name="arrow-button"
        :class="['icon-tag', { 'icon-tag--flipped': isOpen }]"
        width="25"
        height="25"
        stroke="transparent"
        @click="toggleSidebar"
      />
    </div>
  </div>
</template>

<script setup>
import ListItem from './ListItem.vue';
import Version from './Version.vue';
import { AccessPermissionsEnum } from '@/router/constants/';
import { useAuthService } from '@/modules/auth/auth.service';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { getAppModuleRegistry } from '@/modules';
const { checkHasPermission } = useAuthService();
const store = useStore();
const appModuleRegistry = getAppModuleRegistry();
const isOpen = ref(true);
const widthSidebar = computed(() => {
  return isOpen.value ? '270px' : '80px';
});
const tagSidebar = computed(() => {
  return isOpen.value ? '0' : '-13px';
});
const userRole = computed(() => store.getters.role);

const baseSideMenu = [
  {
    routeName: 'main',
    text: 'leftSideMenu.main',
    icon: 'home',
    permissions: [AccessPermissionsEnum.CAN_READ_MAIN],
    place: 'top',
    paths: [],
  },
  {
    routeName: 'merchants',
    text: 'leftSideMenu.merchants',
    icon: 'three-users',
    permissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
    place: 'top',
    paths: ['merchants'],
  },
  {
    routeName: 'agents',
    text: 'leftSideMenu.agents',
    icon: 'agents',
    permissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
    place: 'top',
    paths: ['agents'],
  },
  {
    routeName: 'wallet',
    text: 'leftSideMenu.pselection',
    icon: 'medal-star',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_PSELECTION, AccessPermissionsEnum.CAN_READ_WALLET],
    place: 'top',
    paths: ['/loyalty'],
  },
  {
    routeName: 'points',
    text: 'leftSideMenu.pointsOfSale',
    icon: 'map-pin-line',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
    place: 'top',
    paths: ['points'],
  },
  {
    routeName: 'catalog:settings',
    text: 'leftSideMenu.catalog',
    icon: 'qr-code',
    permissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
    place: 'top',
    paths: ['catalog'],
  },

  {
    text: 'leftSideMenu.staff',
    routeName: 'staff:list',
    icon: 'three-users',
    permissions: [AccessPermissionsEnum.CAN_READ_STAFF],
    place: 'top',
    paths: ['staff'],
  },
  {
    routeName: 'crm',
    text: 'leftSideMenu.crm',
    icon: 'crm',
    permissions: [AccessPermissionsEnum.CAN_READ_CRM],
    place: 'top',
    paths: ['crm'],
  },
  {
    routeName: 'broadcast',
    text: 'leftSideMenu.broadcast',
    icon: 'broadcast',
    permissions: [AccessPermissionsEnum.CAN_READ_CRM],
    place: 'top',
    paths: ['/broadcast'],
  },
  {
    routeName: 'statistic',
    text: 'leftSideMenu.statistic',
    icon: 'statistic',
    permissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
    place: 'top',
    paths: ['/statistic'],
  },
  {
    routeName: 'integrations',
    text: 'leftSideMenu.integrations',
    icon: 'puzzle',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
    place: 'bottom',
    paths: ['/integrations'],
  },
  {
    routeName: 'faq:default',
    text: 'leftSideMenu.faq',
    icon: 'info',
    permissions: [AccessPermissionsEnum.CAN_READ_FAQ],
    place: 'bottom',
    paths: ['faq'],
  },
  {
    routeName: 'support',
    text: 'leftSideMenu.support',
    icon: 'gear',
    permissions: [AccessPermissionsEnum.CAN_READ_SUPPORT],
    place: 'bottom',
    paths: ['support'],
  },
];

const ListSideMenu = computed(() => [
  ...baseSideMenu,
  ...appModuleRegistry.getMenuItems(store.getters['moduleConfig/config']),
]);
const ListSideMenuFiltered = computed(() =>
  ListSideMenu.value?.filter((item) => {
    if (userRole.value === 'back-office' && (item.routeName === 'agents' || item.moduleKey === 'education')) {
      return false;
    }
    if (item.roles?.length && !item.roles.includes(userRole.value)) return false;
    if (item.alwaysVisible) return true;
    if (
      userRole.value === 'operator' &&
      (item.permissions?.includes(AccessPermissionsEnum.CAN_READ_STATISTIC) ||
        item.permissions?.includes(AccessPermissionsEnum.CAN_READ_CATALOG_POINTS))
    ) {
      return true;
    }
    return checkHasPermission(item.permissions || []);
  }),
);
const listMenu = (lsp) => ListSideMenuFiltered?.value?.filter((item) => item.place === lsp);
function toggleSidebar() {
  isOpen.value = !isOpen.value;
}
</script>

<style lang="scss">
.left-container {
  // background-color: var(--color-gray-light);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 10;
  &__wrapper {
    position: relative;
    width: v-bind(widthSidebar);
    min-width: v-bind(widthSidebar);
    max-width: v-bind(widthSidebar);
    margin: 16px;
    margin-right: 0px;
    border-radius: 16px;
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.05);
    transition: 0.4s ease-in-out;
  }

  &__top,
  &__bottom {
    display: flex;
    flex-direction: column;

    & > * + * {
      margin-top: 4px;
    }

    width: 100%;
  }

  transition: 0.4s;
}

.icon-tag {
  position: absolute;
  right: v-bind(tagSidebar);
  top: 50%;
  transform: translateY(-50%) rotateY(180deg) !important;
  cursor: pointer;
  transition:
    transform 0.4s ease-in-out,
    right 0.4s ease-in-out;
  transform-style: preserve-3d;

  &--flipped {
    transform: translateY(-50%) rotateY(0deg) !important;
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  min-height: 64px;
  width: 100%;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.logo-fade-enter-active,
.logo-fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.logo-fade-enter-from,
.logo-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
